/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 *
 * @typedef {Partial<Point>} PointLike
 *
 * @typedef {Object} PositionLike
 * @property {PointLike} [start]
 * @property {PointLike} [end]
 *
 * @typedef {Object} NodeLike
 * @property {PositionLike} [position]
 */
export var pointStart = point('start');
export var pointEnd = point('end');
/**
 * Get the positional info of `node`.
 *
 * @param {NodeLike} [node]
 * @returns {Position}
 */

export function position(node) {
  return {
    start: pointStart(node),
    end: pointEnd(node)
  };
}
/**
 * Get the positional info of `node`.
 *
 * @param {'start'|'end'} type
 */

function point(type) {
  return point;
  /**
   * Get the positional info of `node`.
   *
   * @param {NodeLike} [node]
   * @returns {Point}
   */

  function point(node) {
    /** @type {Point} */
    // @ts-ignore looks like a point
    var point = node && node.position && node.position[type] || {};
    return {
      line: point.line || null,
      column: point.column || null,
      offset: point.offset > -1 ? point.offset : null
    };
  }
}